// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState as getDefaultCriteriaState} from '../state/criteria';
import actions from '../../actions-list';
import {updateKeyValueSelectionList} from '../../../shared/services/list-selections';

const updateCreditMemoCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

const selectCreditMemoIssueDate = (state, action) =>
    Criteria.update(state, {
        dateIssued: {
            from: {
                $set: action.creditMemoIssueDate.from
            },
            to: {
                $set: action.creditMemoIssueDate.to
            }
        }
    });

const resetCreditMemoCriteria = state => {

    const defaultCriteria = getDefaultCriteriaState();

    return Criteria.update(defaultCriteria, {
        claimTypes: {
            allowed: {
                $set: state.claimTypes.allowed
            },
            selected: {
                $set: state.claimTypes.allowed
            }
        }
    });

};

const readClaimTypes = (state, action) =>
    Criteria.update(state, {
        claimTypes: {
            allowed: {
                $set: action.claimTypes
            },
            selected: {
                $set: action.claimTypes
            }
        }
    });

const selectClaimType = (state, action) =>
    Criteria.update(state, {
        claimTypes: {
            selected: {
                $set: updateKeyValueSelectionList(
                    action.claimType,
                    action.isSelected,
                    state.claimTypes.selected
                )
            }
        }
    });

const selectAllClaimTypes = state => {

    const toggleSelectedClaimTypesState = state.claimTypes.selected.length > 0 ?
        [] :
        state.claimTypes.allowed;

    return Criteria.update(state, {
        claimTypes: {
            selected: {
                $set: toggleSelectedClaimTypesState
            }
        }
    });

};

export default (state = getDefaultCriteriaState(), action) => {

    const actionTypes = {
        [actions.UPDATE_CREDIT_MEMO_CRITERIA]: updateCreditMemoCriteria,
        [actions.READ_CREDIT_MEMO_CLAIM_TYPES]: readClaimTypes,
        [actions.RESET_CREDIT_MEMO_REPORT]: resetCreditMemoCriteria,
        [actions.SELECT_CREDIT_MEMO_CLAIM_TYPE]: selectClaimType,
        [actions.SELECT_CREDIT_MEMO_ISSUE_DATE]: selectCreditMemoIssueDate,
        [actions.SELECT_ALL_CREDIT_MEMO_CLAIM_TYPES]: selectAllClaimTypes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/credit-memo/reducers/criteria.js